import { render, staticRenderFns } from "./close-case.vue?vue&type=template&id=e1c81540&scoped=true&"
import script from "./close-case.vue?vue&type=script&lang=js&"
export * from "./close-case.vue?vue&type=script&lang=js&"
import style0 from "./close-case.vue?vue&type=style&index=0&id=e1c81540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c81540",
  null
  
)

export default component.exports